import { CapacitorCookies, SetCookieOptions, DeleteCookieOptions, ClearCookieOptions } from '@capacitor/core'
import { GetCookieOptions } from '@capacitor/core/types/core-plugins'

const getCookies = () => {
  return document.cookie
}

const getCapacitorCookies = async (options?: GetCookieOptions | undefined) => {
  const cookies = await CapacitorCookies.getCookies(options)
  return cookies;
}

const setCapacitorCookie = async (options: SetCookieOptions) => {
  await CapacitorCookies.setCookie(options)
}

const deleteCookie = async (options: DeleteCookieOptions) => {
  await CapacitorCookies.deleteCookie(options)
}

const clearCookiesOnUrl = async (options: ClearCookieOptions) => {
  await CapacitorCookies.clearCookies(options)
}

const clearAllCookies = async () => {
  await CapacitorCookies.clearAllCookies()
}

export { getCookies, setCapacitorCookie, getCapacitorCookies, deleteCookie, clearCookiesOnUrl, clearAllCookies }